<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.createName" placeholder="发布者"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;"> 
                    <el-date-picker
                        style="width:150px;"
                        v-model="form.workDate"
                        type="datetime"
                        placeholder="发布日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                :element-loading-text="loadingText"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column label="标题"  :show-overflow-tooltip="true" width="100">
                    <template slot-scope="scope">
                        {{scope.row.title}}
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="内容" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="createName" label="发送者" width="100"></el-table-column>
                <el-table-column prop="createId" label="身份证" :show-overflow-tooltip="true" width="130"></el-table-column>
                <el-table-column label="回执类型" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.replayType == 1">
                            不需要
                        </div>
                        <div v-else-if="scope.row.replayType == 2">
                            需要
                        </div>
                        <div v-else-if="scope.row.replayType == 3">
                            需要电子签名
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="回执情况" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.replayType == 2 ">
                            已回执{{scope.row.replayCount}}/{{scope.row.replayTotal}}
                        </div>
                        <div v-else-if="scope.row.replayType == 3 ">
                            已签名回执{{scope.row.replayCount}}/{{scope.row.replayTotal}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="gmtCreate" label="发送时间" width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="70px" style="text-align:'left'">
                     <template slot-scope="scope">
                        <el-dropdown size="mini" 
                            v-if="scope.row.replayType == 2 || scope.row.replayType == 3"
                            @command="(command) => handleCommand(command, scope.row)">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleLookFiles" v-if="scope.row.image1Url!='' || scope.row.image1Ur2!=''"
                                    icon="el-icon-circle-check">查看附件</el-dropdown-item>
                                <el-dropdown-item command="handleLookComments"
                                    icon="el-icon-circle-check">回执详情</el-dropdown-item>
                                <!-- <el-dropdown-item command="handledownFiles"  v-if="scope.row.image1Url!='' || scope.row.image1Ur2!=''"
                                    icon="el-icon-download">附件下载</el-dropdown-item> -->
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 查看附件弹出框 -->
        <div v-if="fileInfoVisible">
            <fileInfo ref="fileInfo"></fileInfo>
        </div>
        <!-- 查看评语弹出框 -->
        <div v-if="commentInfoVisible">
            <commentInfo ref="commentInfo"></commentInfo>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import http from '@/common/http'
    import fileInfo from './noticeRelease/fileInfo.vue' 
    import commentInfo from './noticeRelease/commentInfo.vue'

    export default {
        name:"NoticeRelease",
        data(){
            return{
                fileInfoVisible: false,
                commentInfoVisible: false,
                menuName:"",
                loading: false,
                loadingText: "",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    createName:"",
                    deptId:"",
                    workDate:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[]
            }
        },
        components: {
            fileInfo, commentInfo
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key")
            this.getDeptData()
            this.getData()
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl
                let data = {parentId:"0"}
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id
                        }
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            getData(){
                let url  = this.listNoticeReleaseUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    createName:this.form.createName,
                    gmtCreate:(this.form.workDate == null?"":this.form.workDate),
                    deptId:this.form.deptId
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list
                       this.common.total=res.data.total 
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{

                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            handleCommand(command, row) {
                console.log("下拉框："+command)
                if(command == 'handleLookFiles'){
                    this.showFilesData(row)
                }else if(command == 'handleLookComments'){
                    this.showCommentsData(row)
                }else if(command == 'handledownFiles'){
                    this.downloadFiles(row);
                }
            },
            downloadFiles(row) {
                this.loading = true;
                this.loadingText = "正在下载中，下载过程时间可能会比较长，请耐心等待";

                let url = this.noticeReleaseDownloadZipFileUrl;
                let param = new URLSearchParams();
                param.append('id', row.id);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    let data = res.data
                    var blob = new Blob([data])
                    // 创建下载的链接
                    var a = document.createElement('a');
                    a.style.display = 'none';
                    var href = window.URL.createObjectURL(blob);
                    a.href = href;
                    //显示下载文件名 获取后端返回的文件名
                    let filename = res.headers['content-disposition'].split('=')[1]
                    // 文件名中有中文 则对文件名进行转码 decodeURI
                    a.download = decodeURI(filename)
                    // 利用a标签做下载       
                    document.body.appendChild(a);
                    // 点击下载
                    a.click();
                    // 下载后移除元素
                    document.body.removeChild(a);
                    // 释放掉blob对象
                    window.URL.revokeObjectURL(href);
                    this.loading = false;
                }).catch(error => {
                    console.info('response.error' + error.message);
                    this.loading = false;
                });
            },
            showFilesData(row){
                this.fileInfoVisible=true
                this.$nextTick(() => { 
                    this.$refs['fileInfo'].init(row)
                })
            },
            showCommentsData(row){
                this.commentInfoVisible=true
                this.$nextTick(() => { 
                    this.$refs['commentInfo'].init(row.id)
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/notice/NoticeRelease.vue